'use client'

import { motion } from 'framer-motion'

export function TeamGridPlaceholder() {
  return (
    <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
      {Array.from({ length: 6 }).map((_, index) => (
        <motion.div
          // biome-ignore lint/suspicious/noArrayIndexKey: placeholder skeleton tiles
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5, delay: index * 0.06, ease: 'easeOut' }}
          className='relative flex aspect-square flex-col items-center justify-center gap-4 overflow-hidden rounded-2xl border border-borderPrimary bg-backgroundPrimary p-6 shadow-lg'
        >
          <span className='absolute top-4 right-4 rounded-full border border-borderPrimary bg-backgroundSecondary px-2.5 py-1 font-mono text-contentTertiary text-xs uppercase tracking-widest'>
            Wkrótce
          </span>
          <div className='size-24 animate-shimmer-pulse rounded-full bg-backgroundHoverOverlay' />
          <div className='h-4 w-32 animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
          <div className='h-3 w-24 animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
        </motion.div>
      ))}
    </div>
  )
}
